<script setup lang="ts">
import { BaseModal, BaseCircleButton } from '@/components/Base';

defineProps<{
  src: string;
  alt?: string;
}>();

const emit = defineEmits<{
  close: []
}>();
</script>

<template>
  <BaseModal @close="emit('close')">
    <div class="image-modal-content">
      <BaseCircleButton
        class="close-button"
        icon="close"
        variant="secondary"
        :size="48"
        :icon-size="24"
        @click="emit('close')"
      />
      <img :src="src" :alt="alt" class="modal-image" />
    </div>
  </BaseModal>
</template>

<style scoped>
.image-modal-content {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.close-button {
  position: absolute;
  top: var(--spacing-md);
  right: var(--spacing-md);
  background-color: rgba(255, 255, 255, 0.2);
  color: var(--color-text-light);
}

.modal-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  border-radius: var(--border-radius);
}
</style>
